import { render, staticRenderFns } from "./MovimientoDetalles.vue?vue&type=template&id=7c53f865&"
import script from "./MovimientoDetalles.vue?vue&type=script&lang=js&"
export * from "./MovimientoDetalles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports